export default __webpack_public_path__ + "static/AD_8904_rgb-eafdc6b304d282fac73e7400d84fd86b.jpg";